import wrap from 'wraptile';
import {SelectEvent} from '@pluto/enum-type-select';
import {SetStateBoolean} from 'MediaOrders/MediaOrdersTypes';
import {Options} from './types';

export const handleLoad = wrap((setData: Function, [file]: File[]) => setData(file));

export const createFileReader = (data: File, callBack: Function) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);

    reader.onloadend = () => {
        callBack(reader.result as string);
    };
};

export const handleFileLoad = wrap(
    (data: File, setPreview: Function, createFileReader: Function) => {
        if (data) {
            return createFileReader(data, setPreview);
        }
        setPreview('');
    }
);

export const handleOpen = wrap((setOpen: SetStateBoolean) => {
    setOpen(true);
});

export const handleClose = wrap((setOpen: SetStateBoolean, onClear: Function) => {
    setOpen(false);
    onClear();
});

export const handleClear = wrap(
    (setData: Function, setPreview: Function, setOpt: Function, defaultOpts: Options) => {
        setData(null);
        setPreview(null);
        setOpt(defaultOpts);
    }
);

export const enumKeyMapper: {[key: string]: string} = {
    artworkTypes: 'artworkType',
    languages: 'language',
    timedTextTypes: 'timedTextType',
};

export const createFormData = (file: File, opts: Options = {}): FormData => {
    const formData = new FormData();
    formData.append('file', file);

    for (const opt in opts) {
        formData.append(enumKeyMapper[opt], opts[opt] as string);
    }

    return formData;
};

export const handleSubmit = wrap(
    async (action: Function, onClose: Function, data: File, opt: Options) => {
        if (!data) return null;

        const formData = createFormData(data, opt);

        action(formData);
        onClose();
    }
);

export const handleOptsChange = (name: string, value: unknown) => (prev: Options) => {
    return {
        ...prev,
        [name]: value,
    };
};

export const handleChange = wrap(
    (setOpt: Function, handleOptsChange: Function, {target}: SelectEvent) => {
        const {name = '', value = ''} = target;
        const onOptsChange = handleOptsChange(name, value);
        setOpt(onOptsChange);
    }
);
